export default __webpack_public_path__ + "static/media/icon.c443b77a.svg";